export const environment = {
  production: false,
  version: "16.1",
  api: "https://dev.iproofapi.com/api",
  returnUrl: "https://localhost:4501/#",

  defaultRoute: "storage",
}
